import React, { ReactNode } from 'react';
import { Radio } from '@mui/material';
import { LbSelect, TitleWithDescription } from '@infoods/lifebase-ui';
import { Control } from 'react-hook-form';
import classNames from 'classnames';

import classes from './CustomerTypeRadioRow.module.scss';
import { ChallengeCustomerType } from '../../../../../../../constants/challengeCustomerType';
import { ChallengeFormValues } from '../../../../../../../interfaces/ChallengeFormValues';
import { Option } from '../../../../../../../../general-types';
import { LbChip } from '../../../../../../../../shared/components/ui-components';

type CustomerTypeRadioRowProps = {
  value: ChallengeCustomerType;
  selectedValue: ChallengeCustomerType | '';
  control: Control<ChallengeFormValues>;
  availableScoringRuleOptions: Option[];
  title: ReactNode;
  description: ReactNode;
  disabled?: boolean;
};

const CustomerTypeRadioRow = ({
  value,
  selectedValue,
  control,
  title,
  description,
  availableScoringRuleOptions,
  disabled,
}: CustomerTypeRadioRowProps) => {
  return (
    <div className={classes.radioRow}>
      <Radio value={value} id={value} disabled={disabled} />
      <div className={classes.radioContainer}>
        <label
          className={classNames(classes.label, { [classes.disabled]: disabled })}
          htmlFor={value}
        >
          <TitleWithDescription
            title={
              <>
                {title}
                {disabled && (
                  <LbChip
                    label="unavailable"
                    size="extraSmall"
                    color="default"
                    className={classes.chip}
                  />
                )}
              </>
            }
            description={description}
            titleFont="body-14-bold"
          />
        </label>
        {selectedValue === value && (
          <LbSelect
            control={control}
            label="Scoring Rules"
            name="about.scoringRules"
            options={availableScoringRuleOptions}
            rules={{ required: 'Scoring Rules is required' }}
            variant="standard"
            size="small"
          />
        )}
      </div>
    </div>
  );
};

export { CustomerTypeRadioRow };
